export {default} from './GhostInput';



// WEBPACK FOOTER //
// ./src/components/GhostInput/index.ts